// import React, { useState } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [projects, setProjects] = useState([
//     { id: 1, name: "Website", status: "Active", date: "20-04-2026" },
//     { id: 2, name: "Admin Panel", status: "Pending", date: "18-04-2026" },
//   ]);

//   const [search, setSearch] = useState("");

//   const filtered = projects.filter((p) =>
//     p.name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
      
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

      
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "10px",
//           padding: "15px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//         }}
//       >

      
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginBottom: "15px",
//             flexWrap: "wrap",
//             gap: "10px",
//           }}
//         >
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{
//               padding: "8px 12px",
//               borderRadius: "6px",
//               border: "1px solid #ddd",
//               width: "100%",
//               maxWidth: "250px",
//             }}
//           />

//           <button
//             style={{
//               background: "#4a6cf7",
//               color: "#fff",
//               border: "none",
//               padding: "8px 15px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               width: "100%",
//               maxWidth: "150px",
//             }}
//           >
//             + Add Project
//           </button>
//         </div>

//         {/* TABLE */}
//         <div style={{ overflowX: "auto" }}>
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               minWidth: "600px",
//             }}
//           >
//             <thead>
//               <tr style={{ background: "#f5f7fb" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project</th>
//                 <th style={th}>Status</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr
//                   key={p.id}
//                   style={{
//                     borderBottom: "1px solid #eee",
//                     transition: "background 0.3s ease",
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.currentTarget.style.background = "#f5f7fb")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.currentTarget.style.background = "")
//                   }
//                 >
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                       <div
//                         style={{
//                           width: "32px",
//                           height: "32px",
//                           borderRadius: "50%",
//                           background: "#4a6cf7",
//                           color: "#fff",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {p.name.charAt(0)}
//                       </div>
//                       {p.name}
//                     </div>
//                   </td>

//                   <td style={td}>
//                     <span
//                       style={{
//                         padding: "4px 10px",
//                         borderRadius: "20px",
//                         fontSize: "12px",
//                         background:
//                           p.status === "Active" ? "#e6f4ea" : "#fff4e5",
//                         color:
//                           p.status === "Active" ? "#2e7d32" : "#b26a00",
//                       }}
//                     >
//                       {p.status}
//                     </span>
//                   </td>

//                   <td style={td}>{p.date}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
                      
//                       {/* EDIT */}
//                       <div
//                         title="Edit"
//                         style={{
//                           padding: "6px",
//                           borderRadius: "6px",
//                           background: "#eef2ff",
//                           cursor: "pointer",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           transition: "0.2s",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.background = "#4a6cf7";
//                           e.currentTarget.style.color = "#fff";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.background = "#eef2ff";
//                           e.currentTarget.style.color = "#4a6cf7";
//                         }}
//                       >
//                         <GrEdit size={20} />
//                       </div>

                  
//                       <div
//                         title="Delete"
//                         style={{
//                           padding: "6px",
//                           borderRadius: "6px",
//                           background: "#ffecec",
//                           cursor: "pointer",
//                           color: "#dc3545",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           transition: "0.2s",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.background = "#dc3545";
//                           e.currentTarget.style.color = "#fff";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.background = "#ffecec";
//                           e.currentTarget.style.color = "#dc3545";
//                         }}
//                       >
//                         <RiDeleteBin5Line size={20} />
//                       </div>

//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//       </div>
//     </div>
//   );
// };

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
// };

// export default Manageprojects;

// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);

//   const [projects, setProjects] = useState([
//     { id: 1, name: "Website", status: "Active", date: "20-04-2026" },
//     { id: 2, name: "Admin Panel", status: "Pending", date: "18-04-2026" },
//   ]);

//   const [search, setSearch] = useState("");

//   const [showForm, setShowForm] = useState(false);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     p.name.toLowerCase().includes(search.toLowerCase())
//   );

//   // ✅ FETCH SITE MASTERS
//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data))
//       .catch((err) => console.log(err));
//   }, []);

//   // ✅ SUBMIT FUNCTION
//   const handleSubmit = async () => {
//     if (
//       !form.bank_name ||
//       !form.branch ||
//       !form.project_name ||
//       !form.assigned_to
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       await fetch("https://api.d2associates.in/daso//add_project", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(form),
//       });

//       alert("Project Assigned");

//       setShowForm(false);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "10px",
//           padding: "15px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//         }}
//       >
//         {/* SEARCH + BUTTON */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginBottom: "15px",
//             flexWrap: "wrap",
//             gap: "10px",
//           }}
//         >
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{
//               padding: "8px 12px",
//               borderRadius: "6px",
//               border: "1px solid #ddd",
//               width: "100%",
//               maxWidth: "250px",
//             }}
//           />

//           <button
//             style={{
//               background: "#4a6cf7",
//               color: "#fff",
//               border: "none",
//               padding: "8px 15px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               width: "100%",
//               maxWidth: "150px",
//             }}
//             onClick={() => setShowForm(true)}
//           >
//             + Add Project
//           </button>
//         </div>

//         {/* TABLE */}
//         <div style={{ overflowX: "auto" }}>
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               minWidth: "600px",
//             }}
//           >
//             <thead>
//               <tr style={{ background: "#f5f7fb" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project</th>
//                 <th style={th}>Status</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div
//                         style={{
//                           width: "32px",
//                           height: "32px",
//                           borderRadius: "50%",
//                           background: "#4a6cf7",
//                           color: "#fff",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {p.name.charAt(0)}
//                       </div>
//                       {p.name}
//                     </div>
//                   </td>

//                   <td style={td}>
//                     <span
//                       style={{
//                         padding: "4px 10px",
//                         borderRadius: "20px",
//                         fontSize: "12px",
//                         background:
//                           p.status === "Active" ? "#e6f4ea" : "#fff4e5",
//                         color:
//                           p.status === "Active" ? "#2e7d32" : "#b26a00",
//                       }}
//                     >
//                       {p.status}
//                     </span>
//                   </td>

//                   <td style={td}>{p.date}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div style={editBtn}>
//                         <GrEdit size={20} />
//                       </div>

//                       <div style={deleteBtn}>
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* ✅ MODAL */}
//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>Add Project</h3>

//             <input
//               placeholder="Bank Name"
//               value={form.bank_name}
//               onChange={(e) =>
//                 setForm({ ...form, bank_name: e.target.value })
//               }
//               style={input}
//             />

//             <input
//               placeholder="Branch"
//               value={form.branch}
//               onChange={(e) =>
//                 setForm({ ...form, branch: e.target.value })
//               }
//               style={input}
//             />

//             <input
//               placeholder="Project Name"
//               value={form.project_name}
//               onChange={(e) =>
//                 setForm({ ...form, project_name: e.target.value })
//               }
//               style={input}
//             />

       
//           <select
//   value={form.assigned_to}
//   onChange={(e) =>
//     setForm({ ...form, assigned_to: e.target.value })
//   }
//   style={input}
// >
//   <option value="">Select Site Master</option>

//   {siteMasters.map((user) => (
//     <option key={user.id} value={user.id}>
//       {user.name}
//     </option>
//   ))}
// </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>
//                 Submit
//               </button>

//               <button
//                 style={cancelBtn}
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;

// /* ================= STYLES ================= */

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "100%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "8px 15px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ccc",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };


// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);

//   const [projects, setProjects] = useState([]);

//   const [search, setSearch] = useState("");

//   const [showForm, setShowForm] = useState(false);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   // ✅ FETCH SITE MASTERS
//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data))
//       .catch((err) => console.log(err));
//   }, []);

//   // ✅ FETCH PROJECTS (MAIN FIX)
//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data))
//       .catch((err) => console.log(err));
//   }, []);

//   // ✅ SUBMIT FUNCTION
//   const handleSubmit = async () => {
//     if (
//       !form.bank_name ||
//       !form.branch ||
//       !form.project_name ||
//       !form.assigned_to
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       await fetch("https://api.d2associates.in/daso//add_project", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(form),
//       });

//       alert("Project Assigned");

//       setShowForm(false);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });

//       // 🔥 refresh projects after add
//       fetch("https://api.d2associates.in/daso//projects")
//         .then((res) => res.json())
//         .then((data) => setProjects(data));

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "10px",
//           padding: "15px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//         }}
//       >
//         {/* SEARCH + BUTTON */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginBottom: "15px",
//             flexWrap: "wrap",
//             gap: "10px",
//           }}
//         >
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{
//               padding: "8px 12px",
//               borderRadius: "6px",
//               border: "1px solid #ddd",
//               width: "100%",
//               maxWidth: "250px",
//             }}
//           />

//           <button
//             style={{
//               background: "#4a6cf7",
//               color: "#fff",
//               border: "none",
//               padding: "8px 15px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               width: "100%",
//               maxWidth: "150px",
//             }}
//             onClick={() => setShowForm(true)}
//           >
//             + Add Project
//           </button>
//         </div>

//         {/* TABLE */}
//         <div style={{ overflowX: "auto" }}>
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               minWidth: "600px",
//             }}
//           >
//             <thead>
//               <tr style={{ background: "#f5f7fb" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project Name</th>
//                 <th style={th}>Bank Name</th>
//                  <th style={th}>Branch Name</th>
//                  <th style={th}>Assigned To</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//         <tbody>
//   {filtered.map((p, i) => (
//     <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
      
//       <td style={td}>{i + 1}</td>

//       {/* Project Name */}
//       <td style={td}>
//         <div style={{ display: "flex", gap: "10px" }}>
//           <div
//             style={{
//               width: "32px",
//               height: "32px",
//               borderRadius: "50%",
//               background: "#4a6cf7",
//               color: "#fff",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             {(p.project_name || "").charAt(0)}
//           </div>
//           {p.project_name}
//         </div>
//       </td>

//       {/* Bank Name */}
//       <td style={td}>{p.bank_name}</td>

//       {/* Branch Name */}
//       <td style={td}>{p.branch}</td>
//       <td style={td}>{p.assigned_to}</td>

//       {/* Date */}
//       <td style={td}>
//         {p.created_at
//           ? new Date(p.created_at).toLocaleDateString()
//           : "--"}
//       </td>

//       {/* Actions */}
//       <td style={td}>
//         <div style={{ display: "flex", gap: "10px" }}>
//           <div style={editBtn}>
//             <GrEdit size={20} />
//           </div>

//           <div style={deleteBtn}>
//             <RiDeleteBin5Line size={20} />
//           </div>
//         </div>
//       </td>

//     </tr>
//   ))}
// </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MODAL */}
//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>Add Project</h3>

//             <input
//               placeholder="Bank Name"
//               value={form.bank_name}
//               onChange={(e) =>
//                 setForm({ ...form, bank_name: e.target.value })
//               }
//               style={input}
//             />

//             <input
//               placeholder="Branch"
//               value={form.branch}
//               onChange={(e) =>
//                 setForm({ ...form, branch: e.target.value })
//               }
//               style={input}
//             />

//             <input
//               placeholder="Project Name"
//               value={form.project_name}
//               onChange={(e) =>
//                 setForm({ ...form, project_name: e.target.value })
//               }
//               style={input}
//             />

//             <select
//               value={form.assigned_to}
//               onChange={(e) =>
//                 setForm({ ...form, assigned_to: e.target.value })
//               }
//               style={input}
//             >
//               <option value="">Select Site Master</option>

//               {siteMasters.map((user) => (
//                 <option key={user.id} value={user.id}>
//                   {user.name}
//                 </option>
//               ))}
//             </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>
//                 Submit
//               </button>

//               <button
//                 style={cancelBtn}
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;

// /* ================= STYLES ================= */

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "100%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "8px 15px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ccc",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   // ✅ FETCH SITE MASTERS
//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data))
//       .catch((err) => console.log(err));
//   }, []);

//   // ✅ FETCH PROJECTS
//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data))
//       .catch((err) => console.log(err));
//   }, []);

//   // ✅ SUBMIT FUNCTION
//   const handleSubmit = async () => {
//     if (
//       !form.bank_name ||
//       !form.branch ||
//       !form.project_name ||
//       !form.assigned_to
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       await fetch("https://api.d2associates.in/daso//add_project", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(form),
//       });

//       alert("Project Assigned");

//       setShowForm(false);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });

//       // refresh
//       fetch("https://api.d2associates.in/daso//projects")
//         .then((res) => res.json())
//         .then((data) => setProjects(data));

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "10px",
//           padding: "15px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//         }}
//       >
//         {/* SEARCH + BUTTON */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginBottom: "15px",
//             flexWrap: "wrap",
//             gap: "10px",
//           }}
//         >
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{
//               padding: "8px 12px",
//               borderRadius: "6px",
//               border: "1px solid #ddd",
//               width: "100%",
//               maxWidth: "250px",
//             }}
//           />

//           <button
//             style={{
//               background: "#4a6cf7",
//               color: "#fff",
//               border: "none",
//               padding: "8px 15px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               width: "100%",
//               maxWidth: "150px",
//             }}
//             onClick={() => setShowForm(true)}
//           >
//             + Add Project
//           </button>
//         </div>

//         {/* TABLE */}
//         <div style={{ overflowX: "auto" }}>
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               minWidth: "600px",
//             }}
//           >
//             <thead>
//               <tr style={{ background: "#f5f7fb" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project Name</th>
//                 <th style={th}>Bank Name</th>
//                 <th style={th}>Branch Name</th>
//                 <th style={th}>Assigned To</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div
//                         style={{
//                           width: "32px",
//                           height: "32px",
//                           borderRadius: "50%",
//                           background: "#4a6cf7",
//                           color: "#fff",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {(p.project_name || "").charAt(0)}
//                       </div>
//                       {p.project_name}
//                     </div>
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>
//                   <td style={td}>{p.assigned_to}</td>

//                   <td style={td}>
//                     {p.created_at
//                       ? new Date(p.created_at).toLocaleDateString()
//                       : "--"}
//                   </td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div style={editBtn}>
//                         <GrEdit size={20} />
//                       </div>

//                       <div style={deleteBtn}>
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MODAL */}
//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>Add Project</h3>

//             <input
//               placeholder="Bank Name"
//               value={form.bank_name}
//               onChange={(e) =>
//                 setForm({ ...form, bank_name: e.target.value })
//               }
//               style={input}
//             />

//             <input
//               placeholder="Branch"
//               value={form.branch}
//               onChange={(e) =>
//                 setForm({ ...form, branch: e.target.value })
//               }
//               style={input}
//             />

//             <input
//               placeholder="Project Name"
//               value={form.project_name}
//               onChange={(e) =>
//                 setForm({ ...form, project_name: e.target.value })
//               }
//               style={input}
//             />

//             {/* 🔥 FIXED DROPDOWN */}
//             <select
//               value={form.assigned_to}
//               onChange={(e) =>
//                 setForm({
//                   ...form,
//                   assigned_to: Number(e.target.value),
//                 })
//               }
//               style={input}
//             >
//               <option value="">Select Site Master</option>

//               {siteMasters.map((user) => (
//                 <option key={user.id} value={user.id}>
//                   {user.name}
//                 </option>
//               ))}
//             </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>
//                 Submit
//               </button>

//               <button
//                 style={cancelBtn}
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;

// /* ================= STYLES ================= */

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "100%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "8px 15px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ccc",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };


// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   // ✅ FETCH SITE MASTERS
//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data))
//       .catch((err) => console.log(err));
//   }, []);

//   // ✅ FETCH PROJECTS
//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data))
//       .catch((err) => console.log(err));
//   }, []);

//   // ✅ SUBMIT FUNCTION
//   const handleSubmit = async () => {
//     if (
//       !form.bank_name ||
//       !form.branch ||
//       !form.project_name ||
//       !form.assigned_to
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       await fetch("https://api.d2associates.in/daso//add_project", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(form),
//       });

//       alert("Project Assigned");

//       setShowForm(false);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });

//       // refresh
//       fetch("https://api.d2associates.in/daso//projects")
//         .then((res) => res.json())
//         .then((data) => setProjects(data));

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "10px",
//           padding: "15px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//         }}
//       >
//         {/* SEARCH + BUTTON */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginBottom: "15px",
//             flexWrap: "wrap",
//             gap: "10px",
//           }}
//         >
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{
//               padding: "8px 12px",
//               borderRadius: "6px",
//               border: "1px solid #ddd",
//               width: "100%",
//               maxWidth: "250px",
//             }}
//           />

//           <button
//             style={{
//               background: "#4a6cf7",
//               color: "#fff",
//               border: "none",
//               padding: "8px 15px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               width: "100%",
//               maxWidth: "150px",
//             }}
//             onClick={() => setShowForm(true)}
//           >
//             + Add Project
//           </button>
//         </div>

//         {/* TABLE */}
//         <div style={{ overflowX: "auto" }}>
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               minWidth: "600px",
//             }}
//           >
//             <thead>
//               <tr style={{ background: "#f5f7fb" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project Name</th>
//                 <th style={th}>Bank Name</th>
//                 <th style={th}>Branch Name</th>
//                 <th style={th}>Assigned To</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div
//                         style={{
//                           width: "32px",
//                           height: "32px",
//                           borderRadius: "50%",
//                           background: "#4a6cf7",
//                           color: "#fff",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {(p.project_name || "").charAt(0)}
//                       </div>
//                       {p.project_name}
//                     </div>
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>

//                   {/* ✅ FIXED */}
//                   <td style={td}>
//                     {p.assigned_to ? p.assigned_to : "Not Assigned"}
//                   </td>

//                   <td style={td}>
//                     {p.created_at
//                       ? new Date(p.created_at).toLocaleDateString()
//                       : "--"}
//                   </td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div style={editBtn}>
//                         <GrEdit size={20} />
//                       </div>

//                       <div style={deleteBtn}>
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MODAL */}
//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>Add Project</h3>

//             <input
//               placeholder="Bank Name"
//               value={form.bank_name}
//               onChange={(e) =>
//                 setForm({ ...form, bank_name: e.target.value })
//               }
//               style={input}
//             />

//             <input
//               placeholder="Branch"
//               value={form.branch}
//               onChange={(e) =>
//                 setForm({ ...form, branch: e.target.value })
//               }
//               style={input}
//             />

//             <input
//               placeholder="Project Name"
//               value={form.project_name}
//               onChange={(e) =>
//                 setForm({ ...form, project_name: e.target.value })
//               }
//               style={input}
//             />

//             {/* ✅ FIXED DROPDOWN */}
//             <select
//               value={form.assigned_to}
//               onChange={(e) =>
//                 setForm({
//                   ...form,
//                   assigned_to: Number(e.target.value),
//                 })
//               }
//               style={input}
//             >
//               <option value="">Select Site Master</option>

//               {siteMasters.map((user) => (
//                 <option key={user.id} value={user.id}>
//                   {user.name}
//                 </option>
//               ))}
//             </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>
//                 Submit
//               </button>

//               <button
//                 style={cancelBtn}
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;

// /* ================= STYLES ================= */

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "100%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "8px 15px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ccc",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data))
//       .catch((err) => console.log(err));
//   }, []);

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data))
//       .catch((err) => console.log(err));
//   }, []);

//   const handleSubmit = async () => {
//     if (
//       !form.bank_name ||
//       !form.branch ||
//       !form.project_name ||
//       !form.assigned_to
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       const payload = {
//         bank_name: form.bank_name.trim(),
//         branch: form.branch.trim(),
//         project_name: form.project_name.trim(),
//         assigned_to: Number(form.assigned_to),
//       };

//       if (editId) {
//         await fetch(`https://api.d2associates.in/daso//update_project/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });

//         alert("Project Updated Successfully");
//       } else {
//         await fetch("https://api.d2associates.in/daso//add_project", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });

//         alert("Project Assigned");
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });

//       fetch("https://api.d2associates.in/daso//projects")
//         .then((res) => res.json())
//         .then((data) => setProjects(data));

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "10px",
//           padding: "15px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             marginBottom: "15px",
//             flexWrap: "wrap",
//             gap: "10px",
//           }}
//         >
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{
//               padding: "8px 12px",
//               borderRadius: "6px",
//               border: "1px solid #ddd",
//               width: "100%",
//               maxWidth: "250px",
//             }}
//           />

//           <button
//             style={{
//               background: "#4a6cf7",
//               color: "#fff",
//               border: "none",
//               padding: "8px 15px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               width: "100%",
//               maxWidth: "150px",
//             }}
//             onClick={() => {
//               setShowForm(true);
//               setEditId(null);
//               setForm({
//                 bank_name: "",
//                 branch: "",
//                 project_name: "",
//                 assigned_to: "",
//               });
//             }}
//           >
//             + Add Project
//           </button>
//         </div>

//         <div style={{ overflowX: "auto" }}>
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               minWidth: "600px",
//             }}
//           >
//             <thead>
//               <tr style={{ background: "#f5f7fb" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project Name</th>
//                 <th style={th}>Bank Name</th>
//                 <th style={th}>Branch Name</th>
//                 <th style={th}>Assigned To</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div
//                         style={{
//                           width: "32px",
//                           height: "32px",
//                           borderRadius: "50%",
//                           background: "#4a6cf7",
//                           color: "#fff",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {(p.project_name || "").charAt(0)}
//                       </div>
//                       {p.project_name}
//                     </div>
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>

//                   <td style={td}>
//                     {p.assigned_to ? p.assigned_to : "Not Assigned"}
//                   </td>

//                   <td style={td}>
//                     {p.created_at
//                       ? new Date(p.created_at).toLocaleDateString()
//                       : "--"}
//                   </td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div style={editBtn}>
//                         <GrEdit size={20} />
//                       </div>

//                       {/* ✅ DELETE FIXED */}
//                       <div
//                         style={deleteBtn}
//                         onClick={async () => {
//                           if (!window.confirm("Are you sure you want to delete?")) return;

//                           try {
//                             await fetch(`https://api.d2associates.in/daso//delete_project/${p.id}`, {
//                               method: "DELETE",
//                             });

//                             alert("Project Deleted");

//                             fetch("https://api.d2associates.in/daso//projects")
//                               .then((res) => res.json())
//                               .then((data) => setProjects(data));

//                           } catch (err) {
//                             console.log(err);
//                           }
//                         }}
//                       >
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MODAL SAME */}
//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>{editId ? "Edit Project" : "Add Project"}</h3>

//             <input placeholder="Bank Name" value={form.bank_name} onChange={(e)=>setForm({...form,bank_name:e.target.value})} style={input}/>
//             <input placeholder="Branch" value={form.branch} onChange={(e)=>setForm({...form,branch:e.target.value})} style={input}/>
//             <input placeholder="Project Name" value={form.project_name} onChange={(e)=>setForm({...form,project_name:e.target.value})} style={input}/>

//             <select value={form.assigned_to} onChange={(e)=>setForm({...form,assigned_to:Number(e.target.value)})} style={input}>
//               <option value="">Select Site Master</option>
//               {siteMasters.map((user) => (
//                 <option key={user.id} value={user.id}>{user.name}</option>
//               ))}
//             </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>Submit</button>
//               <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;

// /* STYLES */

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "100%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "8px 15px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ccc",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data))
//       .catch((err) => console.log(err));
//   }, []);

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data))
//       .catch((err) => console.log(err));
//   }, []);

//   const handleSubmit = async () => {
//     if (
//       !form.bank_name ||
//       !form.branch ||
//       !form.project_name ||
//       !form.assigned_to
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       const payload = {
//         bank_name: form.bank_name.trim(),
//         branch: form.branch.trim(),
//         project_name: form.project_name.trim(),
//         assigned_to: Number(form.assigned_to),
//       };

//       if (editId) {
//         await fetch(`https://api.d2associates.in/daso//update_project/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//         alert("Project Updated Successfully");
//       } else {
//         await fetch("https://api.d2associates.in/daso//add_project", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//         alert("Project Assigned");
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });

//       fetch("https://api.d2associates.in/daso//projects")
//         .then((res) => res.json())
//         .then((data) => setProjects(data));

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

//       <div style={container}>
//         {/* TOP BAR */}
//         <div style={topBar}>
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={searchInput}
//           />

//           <button
//             style={addBtn}
//             onClick={() => {
//               setShowForm(true);
//               setEditId(null);
//               setForm({
//                 bank_name: "",
//                 branch: "",
//                 project_name: "",
//                 assigned_to: "",
//               });
//             }}
//           >
//             + Add Project
//           </button>
//         </div>

//         {/* TABLE */}
//         <div style={tableWrapper}>
//           <table style={table}>
//             <thead>
//               <tr style={{ background: "#f5f7fb" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project Name</th>
//                 <th style={th}>Bank Name</th>
//                 <th style={th}>Branch Name</th>
//                 <th style={th}>Assigned To</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div style={avatar}>
//                         {(p.project_name || "").charAt(0)}
//                       </div>
//                       {p.project_name}
//                     </div>
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>

//                   <td style={td}>
//                     {p.assigned_to ? p.assigned_to : "Not Assigned"}
//                   </td>

//                   <td style={td}>
//                     {p.created_at
//                       ? new Date(p.created_at).toLocaleDateString()
//                       : "--"}
//                   </td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div style={editBtn}>
//                         <GrEdit size={20} />
//                       </div>

//                       <div
//                         style={deleteBtn}
//                         onClick={async () => {
//                           if (!window.confirm("Are you sure?")) return;

//                           await fetch(`https://api.d2associates.in/daso//delete_project/${p.id}`, {
//                             method: "DELETE",
//                           });

//                           fetch("https://api.d2associates.in/daso//projects")
//                             .then((res) => res.json())
//                             .then((data) => setProjects(data));
//                         }}
//                       >
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MODAL */}
//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>{editId ? "Edit Project" : "Add Project"}</h3>

//             <input style={input} placeholder="Bank Name" value={form.bank_name} onChange={(e)=>setForm({...form,bank_name:e.target.value})}/>
//             <input style={input} placeholder="Branch" value={form.branch} onChange={(e)=>setForm({...form,branch:e.target.value})}/>
//             <input style={input} placeholder="Project Name" value={form.project_name} onChange={(e)=>setForm({...form,project_name:e.target.value})}/>

//             <select style={input} value={form.assigned_to} onChange={(e)=>setForm({...form,assigned_to:Number(e.target.value)})}>
//               <option value="">Select Site Master</option>
//               {siteMasters.map((u)=>(
//                 <option key={u.id} value={u.id}>{u.name}</option>
//               ))}
//             </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>Submit</button>
//               <button style={cancelBtn} onClick={()=>setShowForm(false)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;

// /* RESPONSIVE STYLES */

// const container = {
//   background: "#fff",
//   borderRadius: "10px",
//   padding: "15px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   width: "100%",
// };

// const topBar = {
//   display: "flex",
//   flexWrap: "wrap",
//   gap: "10px",
//   justifyContent: "space-between",
// };

// const searchInput = {
//   flex: "1",
//   minWidth: "180px",
//   padding: "8px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const addBtn = {
//   padding: "8px 15px",
//   borderRadius: "6px",
//   background: "#4a6cf7",
//   color: "#fff",
//   border: "none",
// };

// const tableWrapper = {
//   overflowX: "auto",
// };

// const table = {
//   width: "100%",
//   minWidth: "600px",
//   borderCollapse: "collapse",
// };

// const th = { padding: "12px", textAlign: "left" };
// const td = { padding: "10px" };

// const avatar = {
//   width: "32px",
//   height: "32px",
//   borderRadius: "50%",
//   background: "#4a6cf7",
//   color: "#fff",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

// const editBtn = { padding: "6px", background: "#eef2ff", borderRadius: "6px" };
// const deleteBtn = { padding: "6px", background: "#ffecec", borderRadius: "6px" };

// const overlay = {
//   position: "fixed",
//   inset: 0,
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "90%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
// };

// const btn = { background: "#4a6cf7", color: "#fff", padding: "8px" };
// const cancelBtn = { background: "#ccc", padding: "8px" };


// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data))
//       .catch((err) => console.log(err));
//   }, []);

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data))
//       .catch((err) => console.log(err));
//   }, []);

// const handleSubmit = async () => {
//   if (!form.bank_name || !form.branch || !form.project_name) {
//     alert("Bank, Branch and Project Name required");
//     return;
//   }

//   try {
//     const payload = {
//       bank_name: form.bank_name.trim(),
//       branch: form.branch.trim(),
//       project_name: form.project_name.trim(),
//       assigned_to: form.assigned_to ? Number(form.assigned_to) : null, // ✅ FIX
//     };

//     if (editId) {
//       await fetch(`https://api.d2associates.in/daso//api/update_project/${editId}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       alert("Project Updated Successfully");
//     } else {
//       await fetch("https://api.d2associates.in/daso//api/add_project", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       alert("Project Created");
//     }

//     setShowForm(false);
//     setEditId(null);

//     setForm({
//       bank_name: "",
//       branch: "",
//       project_name: "",
//       assigned_to: "",
//     });

//     fetch("https://api.d2associates.in/daso//projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data));

//   } catch (err) {
//     console.log(err);
//   }
// };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

//       <div style={container}>
//         <div style={topBar}>
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={searchInput}
//           />

//           <button
//             style={addBtn}
//             onClick={() => {
//               setShowForm(true);
//               setEditId(null);
//               setForm({
//                 bank_name: "",
//                 branch: "",
//                 project_name: "",
//                 assigned_to: "",
//               });
//             }}
//           >
//             + Add Project
//           </button>
//         </div>

//         <div style={tableWrapper}>
//           <table style={table}>
//             <thead>
//               <tr style={{ background: "#D4c2BB" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project Name</th>
//                 <th style={th}>Bank Name</th>
//                 <th style={th}>Branch Name</th>
//                 <th style={th}>Assigned To</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div style={avatar}>
//                         {(p.project_name || "").charAt(0)}
//                       </div>
//                       {p.project_name}
//                     </div>
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>

//                   {/* <td style={td}>
//                     {p.assigned_to ? p.assigned_to : "Not Assigned"}
//                   </td> */}
//                   <td style={td}>
//   {p.assigned_name || "Not Assigned"}
// </td>

//                   <td style={td}>
//                     {p.created_at
//                       ? new Date(p.created_at).toLocaleDateString()
//                       : "--"}
//                   </td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>

                    
//                       <div
//                         style={editBtn}
//                         onClick={() => {
//                           setForm({
//                             bank_name: p.bank_name || "",
//                             branch: p.branch || "",
//                             project_name: p.project_name || "",
//                             assigned_to: p.assigned_to || "",
//                           });

//                           setEditId(p.id);
//                           setShowForm(true);
//                         }}
//                       >
//                         <GrEdit size={20} />
//                       </div>

                 
//                       <div
//                         style={deleteBtn}
//                         onClick={async () => {
//                           if (!window.confirm("Are you sure?")) return;

//                           await fetch(`https://api.d2associates.in/daso//delete_project/${p.id}`, {
//                             method: "DELETE",
//                           });

//                           fetch("https://api.d2associates.in/daso//projects")
//                             .then((res) => res.json())
//                             .then((data) => setProjects(data));
//                         }}
//                       >
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>{editId ? "Edit Project" : "Add Project"}</h3>

//             <input style={input} placeholder="Bank Name" value={form.bank_name} onChange={(e)=>setForm({...form,bank_name:e.target.value})}/>
//             <input style={input} placeholder="Branch" value={form.branch} onChange={(e)=>setForm({...form,branch:e.target.value})}/>
//             <input style={input} placeholder="Project Name" value={form.project_name} onChange={(e)=>setForm({...form,project_name:e.target.value})}/>

//             <select style={input} value={form.assigned_to} onChange={(e)=>setForm({...form,assigned_to:Number(e.target.value)})}>
//               <option value="">Select Site Master</option>
//               {siteMasters.map((u)=>(
//                 <option key={u.id} value={u.id}>{u.name}</option>
//               ))}
//             </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>Submit</button>
//               <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;



// const modal = {
//   background: "#fff",
//   padding: "25px",
//   borderRadius: "12px",
//   width: "90%",
//   maxWidth: "420px",
//   boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
// };

// const input = {
//   width: "100%",
//   padding: "12px",
//   marginBottom: "12px",
//   border: "1px solid #ccc",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "10px 16px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ddd",
//   padding: "10px 16px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// // CONTAINER
// const container = {
//   background: "#fff",
//   borderRadius: "10px",
//   padding: "15px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   width: "100%",
// };


// const topBar = {
//   display: "flex",
//   justifyContent: "space-between",
//   marginBottom: "15px",
//   flexWrap: "wrap",
//   gap: "10px",
// };


// const searchInput = {
//   padding: "8px 12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
//   flex: "1",
//   minWidth: "180px",
// };


// const addBtn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };


// const tableWrapper = {
//   width: "100%",
//   overflowX: "auto",
// };


// const table = {
//   width: "100%",
//   borderCollapse: "collapse",
//   minWidth: "600px",
// };


// const th = {
//   padding: "12px",
//   textAlign: "left",
// };

// const td = {
//   padding: "10px",
// };


// const avatar = {
//   width: "32px",
//   height: "32px",
//   borderRadius: "50%",
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };


// const overlay = {
//   position: "fixed",
//   inset: 0,
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };
// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   /* ✅ HOVER STATE */
//   const [hoveredRow, setHoveredRow] = useState(null);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data))
//       .catch((err) => console.log(err));
//   }, []);

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data))
//       .catch((err) => console.log(err));
//   }, []);

//   const handleSubmit = async () => {
//     if (!form.bank_name || !form.branch || !form.project_name) {
//       alert("Bank, Branch and Project Name required");
//       return;
//     }

//     try {
//       const payload = {
//         bank_name: form.bank_name.trim(),
//         branch: form.branch.trim(),
//         project_name: form.project_name.trim(),
//         assigned_to: form.assigned_to ? Number(form.assigned_to) : null,
//       };

//       if (editId) {
//         await fetch(`https://api.d2associates.in/daso//api/update_project/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//         alert("Project Updated Successfully");
//       } else {
//         await fetch("https://api.d2associates.in/daso//api/add_project", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//         alert("Project Created");
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });

//       fetch("https://api.d2associates.in/daso//projects")
//         .then((res) => res.json())
//         .then((data) => setProjects(data));

//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Projects
//       </h2>

//       <div style={container}>
//         <div style={topBar}>
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={searchInput}
//           />

//           <button
//             style={addBtn}
//             onClick={() => {
//               setShowForm(true);
//               setEditId(null);
//               setForm({
//                 bank_name: "",
//                 branch: "",
//                 project_name: "",
//                 assigned_to: "",
//               });
//             }}
//           >
//             + Add Project
//           </button>
//         </div>

//         <div style={tableWrapper}>
//           <table style={table}>
//             <thead>
//               <tr style={{ background: "#D4c2BB" }}>
//                 <th style={th}>#</th>
//                 <th style={th}>Project Name</th>
//                 <th style={th}>Bank Name</th>
//                 <th style={th}>Branch Name</th>
//                 <th style={th}>Assigned To</th>
//                 <th style={th}>Date</th>
//                 <th style={th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr
//                   key={p.id}
//                   onMouseEnter={() => setHoveredRow(p.id)}
//                   onMouseLeave={() => setHoveredRow(null)}
//                   style={{
//                     borderBottom: "1px solid #eee",
//                     background: hoveredRow === p.id ? "#D4C2BB" : "transparent",
//                     transition: "all 0.2s ease",
//                   }}
//                 >
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div style={avatar}>
//                         {(p.project_name || "").charAt(0)}
//                       </div>
//                       {p.project_name}
//                     </div>
//                   </td>

//                   <td style={td}>{p.bank_name}</td>
//                   <td style={td}>{p.branch}</td>

//                   <td style={td}>
//                     {p.assigned_name || "Not Assigned"}
//                   </td>

//                   <td style={td}>
//                     {p.created_at
//                       ? new Date(p.created_at).toLocaleDateString()
//                       : "--"}
//                   </td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div
//                         style={editBtn}
//                         onClick={() => {
//                           setForm({
//                             bank_name: p.bank_name || "",
//                             branch: p.branch || "",
//                             project_name: p.project_name || "",
//                             assigned_to: p.assigned_to || "",
//                           });

//                           setEditId(p.id);
//                           setShowForm(true);
//                         }}
//                       >
//                         <GrEdit size={20} />
//                       </div>

//                       <div
//                         style={deleteBtn}
//                         onClick={async () => {
//                           if (!window.confirm("Are you sure?")) return;

//                           await fetch(`https://api.d2associates.in/daso//delete_project/${p.id}`, {
//                             method: "DELETE",
//                           });

//                           fetch("https://api.d2associates.in/daso//projects")
//                             .then((res) => res.json())
//                             .then((data) => setProjects(data));
//                         }}
//                       >
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>{editId ? "Edit Project" : "Add Project"}</h3>

//             <input style={input} placeholder="Bank Name" value={form.bank_name} onChange={(e)=>setForm({...form,bank_name:e.target.value})}/>
//             <input style={input} placeholder="Branch" value={form.branch} onChange={(e)=>setForm({...form,branch:e.target.value})}/>
//             <input style={input} placeholder="Project Name" value={form.project_name} onChange={(e)=>setForm({...form,project_name:e.target.value})}/>

//             <select style={input} value={form.assigned_to} onChange={(e)=>setForm({...form,assigned_to:Number(e.target.value)})}>
//               <option value="">Select Site Master</option>
//               {siteMasters.map((u)=>(
//                 <option key={u.id} value={u.id}>{u.name}</option>
//               ))}
//             </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>Submit</button>
//               <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;
// const modal = {
//   background: "#fff",
//   padding: "25px",
//   borderRadius: "12px",
//   width: "90%",
//   maxWidth: "420px",
//   boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
// };

// const input = {
//   width: "100%",
//   padding: "12px",
//   marginBottom: "12px",
//   border: "1px solid #ccc",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "10px 16px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ddd",
//   padding: "10px 16px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const container = {
//   background: "#fff",
//   borderRadius: "10px",
//   padding: "15px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   width: "100%",
// };

// const topBar = {
//   display: "flex",
//   justifyContent: "space-between",
//   marginBottom: "15px",
//   flexWrap: "wrap",
//   gap: "10px",
// };

// const searchInput = {
//   padding: "8px 12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
//   flex: "1",
//   minWidth: "180px",
// };

// const addBtn = {
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
//   width: "100%",
//   maxWidth: "160px",
// };
// const tableWrapper = {
//   width: "100%",
//   overflowX: "auto",
// };

// const table = {
//   width: "100%",
//   borderCollapse: "collapse",
//   minWidth: "600px",
// };

// const th = {
//   padding: "12px",
//   textAlign: "left",
// };

// const td = {
//   padding: "10px",
// };

// const avatar = {
//   width: "32px",
//   height: "32px",
//   borderRadius: "50%",
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

// const overlay = {
//   position: "fixed",
//   inset: 0,
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };
// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [showDelete, setShowDelete] = useState(false);
// const [deleteId, setDeleteId] = useState(null);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data));
//   }, []);

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data));
//   }, []);

//   const handleSubmit = async () => {
//     if (!form.bank_name || !form.branch || !form.project_name) {
//       toast.error("Bank, Branch and Project Name required");
//       return;
//     }

//     try {
//       const payload = {
//         bank_name: form.bank_name.trim(),
//         branch: form.branch.trim(),
//         project_name: form.project_name.trim(),
//         assigned_to: form.assigned_to ? Number(form.assigned_to) : null,
//       };

//       if (editId) {
//         toast.success("Project Updated Successfully"); // ✅ force show

//         await fetch(`https://api.d2associates.in/daso//api/update_project/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//       } else {
//         toast.success("Project Created"); // ✅ force show

//         await fetch("https://api.d2associates.in/daso//api/add_project", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });

//       fetch("https://api.d2associates.in/daso//projects")
//         .then((res) => res.json())
//         .then((data) => setProjects(data));

//     } catch (err) {
//       toast.error("Something went wrong");
//     }
//   };

//   return (
//     <>
//       <ToastContainer position="top-center" autoClose={2000} />

//       <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//         <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//           Manage Projects
//         </h2>

//         <div style={container}>
//           <div style={topBar}>
//             <input
//               type="text"
//               placeholder="Search..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               style={searchInput}
//             />

//             <button
//               style={addBtn}
//               onClick={() => {
//                 setShowForm(true);
//                 setEditId(null);
//                 setForm({
//                   bank_name: "",
//                   branch: "",
//                   project_name: "",
//                   assigned_to: "",
//                 });
//               }}
//             >
//               + Add Project
//             </button>
//           </div>

//           <div style={tableWrapper}>
//             <table style={table}>
//               <thead>
//                 <tr style={{ background: "#D4c2BB" }}>
//                   <th style={th}>#</th>
//                   <th style={th}>Project Name</th>
//                   <th style={th}>Bank Name</th>
//                   <th style={th}>Branch Name</th>
//                   <th style={th}>Assigned To</th>
//                   <th style={th}>Date</th>
//                   <th style={th}>Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {filtered.map((p, i) => (
//                   <tr
//                     key={p.id}
//                     onMouseEnter={() => setHoveredRow(p.id)}
//                     onMouseLeave={() => setHoveredRow(null)}
//                     style={{
//                       borderBottom: "1px solid #eee",
//                       background: hoveredRow === p.id ? "#D4C2BB" : "transparent",
//                       transition: "all 0.2s ease",
//                     }}
//                   >
//                     <td style={td}>{i + 1}</td>

//                     <td style={td}>
//                       <div style={{ display: "flex", gap: "10px" }}>
//                         <div style={avatar}>
//                           {(p.project_name || "").charAt(0)}
//                         </div>
//                         {p.project_name}
//                       </div>
//                     </td>

//                     <td style={td}>{p.bank_name}</td>
//                     <td style={td}>{p.branch}</td>

//                     <td style={td}>
//                       {p.assigned_name || "Not Assigned"}
//                     </td>

//                     <td style={td}>
//                       {p.created_at
//                         ? new Date(p.created_at).toLocaleDateString()
//                         : "--"}
//                     </td>

//                     <td style={td}>
//                       <div style={{ display: "flex", gap: "10px" }}>
//                         <div
//                           style={editBtn}
//                           onClick={() => {
//                             setForm({
//                               bank_name: p.bank_name || "",
//                               branch: p.branch || "",
//                               project_name: p.project_name || "",
//                               assigned_to: p.assigned_to || "",
//                             });

//                             setEditId(p.id);
//                             setShowForm(true);
//                           }}
//                         >
//                           <GrEdit size={20} />
//                         </div>

//                         <div
//                           style={deleteBtn}
//                           onClick={async () => {
//                             if (!window.confirm("Are you sure?")) return;

//                             toast.success("Project Deleted"); // ✅ force show

//                             await fetch(`https://api.d2associates.in/daso//delete_project/${p.id}`, {
//                               method: "DELETE",
//                             });

//                             fetch("https://api.d2associates.in/daso//projects")
//                               .then((res) => res.json())
//                               .then((data) => setProjects(data));
//                           }}
//                         >
//                           <RiDeleteBin5Line size={20} />
//                         </div>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {showForm && (
//           <div style={overlay}>
//             <div style={modal}>
//               <h3>{editId ? "Edit Project" : "Add Project"}</h3>

//               <input style={input} placeholder="Bank Name" value={form.bank_name} onChange={(e)=>setForm({...form,bank_name:e.target.value})}/>
//               <input style={input} placeholder="Branch" value={form.branch} onChange={(e)=>setForm({...form,branch:e.target.value})}/>
//               <input style={input} placeholder="Project Name" value={form.project_name} onChange={(e)=>setForm({...form,project_name:e.target.value})}/>

//               <select style={input} value={form.assigned_to} onChange={(e)=>setForm({...form,assigned_to:Number(e.target.value)})}>
//                 <option value="">Select Site Master</option>
//                 {siteMasters.map((u)=>(<option key={u.id} value={u.id}>{u.name}</option>))}
//               </select>

//               <div style={{ display: "flex", gap: "10px" }}>
//                 <button style={btn} onClick={handleSubmit}>Submit</button>
//                 <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Manageprojects;
// const modal = {
//   background: "#fff",
//   padding: "25px",
//   borderRadius: "12px",
//   width: "90%",
//   maxWidth: "420px",
//   boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
// };

// const input = {
//   width: "100%",
//   padding: "12px",
//   marginBottom: "12px",
//   border: "1px solid #ccc",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "10px 16px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ddd",
//   padding: "10px 16px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const container = {
//   background: "#fff",
//   borderRadius: "10px",
//   padding: "15px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   width: "100%",
// };

// const topBar = {
//   display: "flex",
//   justifyContent: "space-between",
//   marginBottom: "15px",
//   flexWrap: "wrap",
//   gap: "10px",
// };

// const searchInput = {
//   padding: "8px 12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
//   flex: "1",
//   minWidth: "180px",
// };

// const addBtn = {
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
//   width: "100%",
//   maxWidth: "160px",
// };
// const tableWrapper = {
//   width: "100%",
//   overflowX: "auto",
// };

// const table = {
//   width: "100%",
//   borderCollapse: "collapse",
//   minWidth: "600px",
// };

// const th = {
//   padding: "12px",
//   textAlign: "left",
// };

// const td = {
//   padding: "10px",
// };

// const avatar = {
//   width: "32px",
//   height: "32px",
//   borderRadius: "50%",
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

// const overlay = {
//   position: "fixed",
//   inset: 0,
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Manageprojects = () => {
//   const [siteMasters, setSiteMasters] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [hoveredRow, setHoveredRow] = useState(null);

//   // ✅ DELETE STATE
//   const [showDelete, setShowDelete] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);

//   const [form, setForm] = useState({
//     bank_name: "",
//     branch: "",
//     project_name: "",
//     assigned_to: "",
//   });

//   const filtered = projects.filter((p) =>
//     (p.project_name || "").toLowerCase().includes(search.toLowerCase())
//   );

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/sitemasters")
//       .then((res) => res.json())
//       .then((data) => setSiteMasters(data));
//   }, []);

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data));
//   }, []);

//   const handleSubmit = async () => {
//     if (!form.bank_name || !form.branch || !form.project_name) {
//       toast.error("Bank, Branch and Project Name required");
//       return;
//     }

//     try {
//       const payload = {
//         bank_name: form.bank_name.trim(),
//         branch: form.branch.trim(),
//         project_name: form.project_name.trim(),
//         assigned_to: form.assigned_to ? Number(form.assigned_to) : null,
//       };

//       if (editId) {
//         toast.success("Project Updated Successfully");

//         await fetch(`https://api.d2associates.in/daso//api/update_project/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//       } else {
//         toast.success("Project Created");

//         await fetch("https://api.d2associates.in/daso//api/add_project", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         bank_name: "",
//         branch: "",
//         project_name: "",
//         assigned_to: "",
//       });

//       fetch("https://api.d2associates.in/daso//api/projects")
//         .then((res) => res.json())
//         .then((data) => setProjects(data));

//     } catch (err) {
//       toast.error("Something went wrong");
//     }
//   };

//   // ✅ CONFIRM DELETE FUNCTION
//   const confirmDelete = async () => {
//     toast.success("Project Deleted");

//     await fetch(`https://api.d2associates.in/daso//api/delete_project/${deleteId}`, {
//       method: "DELETE",
//     });

//     setShowDelete(false);
//     setDeleteId(null);

//     fetch("https://api.d2associates.in/daso//api/projects")
//       .then((res) => res.json())
//       .then((data) => setProjects(data));
//   };

//   return (
//     <>
//       <ToastContainer position="top-center" autoClose={2000} />

//       <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//         <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//           Manage Projects
//         </h2>

//         <div style={container}>
//           <div style={topBar}>
//             <input
//               type="text"
//               placeholder="Search..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               style={searchInput}
//             />

//             <button
//               style={addBtn}
//               onClick={() => {
//                 setShowForm(true);
//                 setEditId(null);
//                 setForm({
//                   bank_name: "",
//                   branch: "",
//                   project_name: "",
//                   assigned_to: "",
//                 });
//               }}
//             >
//               + Add Project
//             </button>
//           </div>

//           <div style={tableWrapper}>
//             <table style={table}>
//               <thead>
//                 <tr style={{ background: "#D4c2BB" }}>
//                   <th style={th}>#</th>
//                   <th style={th}>Project Name</th>
//                   <th style={th}>Bank Name</th>
//                   <th style={th}>Branch Name</th>
//                   <th style={th}>Assigned To</th>
//                   <th style={th}>Date</th>
//                   <th style={th}>Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {filtered.map((p, i) => (
//                   <tr
//                     key={p.id}
//                     onMouseEnter={() => setHoveredRow(p.id)}
//                     onMouseLeave={() => setHoveredRow(null)}
//                     style={{
//                       borderBottom: "1px solid #eee",
//                       background: hoveredRow === p.id ? "#D4C2BB" : "transparent",
//                       transition: "0.2s",
//                     }}
//                   >
//                     <td style={td}>{i + 1}</td>

//                     <td style={td}>
//                       <div style={{ display: "flex", gap: "10px" }}>
//                         <div style={avatar}>
//                           {(p.project_name || "").charAt(0)}
//                         </div>
//                         {p.project_name}
//                       </div>
//                     </td>

//                     <td style={td}>{p.bank_name}</td>
//                     <td style={td}>{p.branch}</td>

//                     <td style={td}>
//                       {p.assigned_name || "Not Assigned"}
//                     </td>

//                     <td style={td}>
//                       {p.created_at
//                         ? new Date(p.created_at).toLocaleDateString()
//                         : "--"}
//                     </td>

//                     <td style={td}>
//                       <div style={{ display: "flex", gap: "10px" }}>
//                         <div
//                           style={editBtn}
//                           onClick={() => {
//                             setForm({
//                               bank_name: p.bank_name || "",
//                               branch: p.branch || "",
//                               project_name: p.project_name || "",
//                               assigned_to: p.assigned_to || "",
//                             });

//                             setEditId(p.id);
//                             setShowForm(true);
//                           }}
//                         >
//                           <GrEdit size={20} />
//                         </div>

//                         {/* ✅ DELETE CLICK */}
//                         <div
//                           style={deleteBtn}
//                           onClick={() => {
//                             setDeleteId(p.id);
//                             setShowDelete(true);
//                           }}
//                         >
//                           <RiDeleteBin5Line size={20} />
//                         </div>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* FORM MODAL */}
//         {showForm && (
//           <div style={overlay}>
//             <div style={modal}>
//               <h3>{editId ? "Edit Project" : "Add Project"}</h3>

//               <input style={input} placeholder="Bank Name" value={form.bank_name} onChange={(e)=>setForm({...form,bank_name:e.target.value})}/>
//               <input style={input} placeholder="Branch" value={form.branch} onChange={(e)=>setForm({...form,branch:e.target.value})}/>
//               <input style={input} placeholder="Project Name" value={form.project_name} onChange={(e)=>setForm({...form,project_name:e.target.value})}/>

//               <select style={input} value={form.assigned_to} onChange={(e)=>setForm({...form,assigned_to:Number(e.target.value)})}>
//                 <option value="">Select Site Master</option>
//                 {siteMasters.map((u)=>(
//                   <option key={u.id} value={u.id}>{u.name}</option>
//                 ))}
//               </select>

//               <div style={{ display: "flex", gap: "10px" }}>
//                 <button style={btn} onClick={handleSubmit}>Submit</button>
//                 <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ✅ DELETE CONFIRM MODAL */}
//         {showDelete && (
//           <div style={overlay}>
//             <div style={modal}>
//               <h3>Confirm Delete</h3>
//               <p>Are you sure you want to delete this project?</p>

//               <div style={{ display: "flex", gap: "10px" }}>
//                 <button style={btn} onClick={confirmDelete}>
//                   Yes Delete
//                 </button>

//                 <button
//                   style={cancelBtn}
//                   onClick={() => {
//                     setShowDelete(false);
//                     setDeleteId(null);
//                   }}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Manageprojects;


// /* SAME STYLES (NO CHANGE) */

// const modal = {
//   background: "#fff",
//   padding: "25px",
//   borderRadius: "12px",
//   width: "90%",
//   maxWidth: "420px",
// };

// const input = {
//   width: "100%",
//   padding: "12px",
//   marginBottom: "12px",
//   border: "1px solid #ccc",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   padding: "10px 16px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ddd",
//   padding: "10px 16px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const container = {
//   background: "#fff",
//   borderRadius: "10px",
//   padding: "15px",
// };

// const topBar = {
//   display: "flex",
//   justifyContent: "space-between",
//   marginBottom: "15px",
// };

// const searchInput = {
//   padding: "8px 12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
// };

// const addBtn = {
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const tableWrapper = {
//   width: "100%",
//   overflowX: "auto",
// };

// const table = {
//   width: "100%",
//   borderCollapse: "collapse",
// };

// const th = {
//   padding: "12px",
//   textAlign: "left",
// };

// const td = {
//   padding: "10px",
// };

// const avatar = {
//   width: "32px",
//   height: "32px",
//   borderRadius: "50%",
//   background: "#D4C2BB",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

// const overlay = {
//   position: "fixed",
//   inset: 0,
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

import React, { useState, useEffect } from "react";
import { GrEdit } from "react-icons/gr";
import { RiDeleteBin5Line } from "react-icons/ri";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Manageprojects = () => {
  const [siteMasters, setSiteMasters] = useState([]);
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);

  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [form, setForm] = useState({
    bank_name: "",
    branch: "",
    project_name: "",
    assigned_to: "",
  });

  const filtered = projects.filter((p) =>
    (p.project_name || "").toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    fetch("https://api.d2associates.in/sitemasters")
      .then((res) => res.json())
      .then((data) => setSiteMasters(data));
  }, []);

  useEffect(() => {
    fetch("https://api.d2associates.in/projects")
      .then((res) => res.json())
        .then((data) => {
      const filtered = data.filter(item => item.status !== "reviewed");
      setProjects(filtered);
    });
  }, []);

  const handleSubmit = async () => {
    if (!form.bank_name || !form.branch || !form.project_name) {
      toast.error("Bank, Branch and Project Name required");
      return;
    }

    try {
      const payload = {
        bank_name: form.bank_name.trim(),
        branch: form.branch.trim(),
        project_name: form.project_name.trim(),
        assigned_to: form.assigned_to ? Number(form.assigned_to) : null,
      };

      if (editId) {
        toast.success("Project Updated Successfully");

        await fetch(`https://api.d2associates.in/update_project/${editId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else {
        toast.success("Project Created Successfully");

        await fetch("https://api.d2associates.in/add_project", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      }

      setShowForm(false);
      setEditId(null);

      setForm({
        bank_name: "",
        branch: "",
        project_name: "",
        assigned_to: "",
      });

      fetch("https://api.d2associates.in/projects")
        .then((res) => res.json())
          .then((data) => {
      const filtered = data.filter(item => item.status !== "reviewed");
      setProjects(filtered);
          }
        )

    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const confirmDelete = async () => {
    toast.success("Project Deleted Successfully");

    await fetch(`https://api.d2associates.in/delete_project/${deleteId}`, {
      method: "DELETE",
    });

    setShowDelete(false);
    setDeleteId(null);

    fetch("https://api.d2associates.in/projects")
      .then((res) => res.json())
         .then((data) => {
      const filtered = data.filter(item => item.status !== "reviewed");
      setProjects(filtered);
  })
  };

  return (
    <>
      
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

      <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
        <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
          Manage Projects
        </h2>

        <div style={container}>
          <div style={topBar}>
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={searchInput}
            />

            <button
              style={addBtn}
              onClick={() => {
                setShowForm(true);
                setEditId(null);
                setForm({
                  bank_name: "",
                  branch: "",
                  project_name: "",
                  assigned_to: "",
                });
              }}
            >
              + Add Project
            </button>
          </div>

          <div style={tableWrapper}>
            <table style={table}>
              <thead>
                <tr style={{ background: "#D4c2BB" }}>
                  <th style={th}>#</th>
                  <th style={th}>Project Name</th>
                  <th style={th}>Bank Name</th>
                  <th style={th}>Branch Name</th>
                  <th style={th}>Assigned To</th>
                  <th style={th}>Date</th>
                  <th style={th}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {filtered.map((p, i) => (
                  <tr
                    key={p.id}
                    onMouseEnter={() => setHoveredRow(p.id)}
                    onMouseLeave={() => setHoveredRow(null)}
                    style={{
                      borderBottom: "1px solid #eee",
                      background: hoveredRow === p.id ? "#D4C2BB" : "transparent",
                      transition: "0.2s",
                    }}
                  >
                    <td style={td}>{i + 1}</td>

                    <td style={td}>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <div style={avatar}>
                          {(p.project_name || "").charAt(0)}
                        </div>
                        {p.project_name}
                      </div>
                    </td>

                    <td style={td}>{p.bank_name}</td>
                    <td style={td}>{p.branch}</td>

                    <td style={td}>
                      {p.assigned_name || "Not Assigned"}
                    </td>

                    <td style={td}>
                      {p.created_at
                        ? new Date(p.created_at).toLocaleDateString()
                        : "--"}
                    </td>

                    <td style={td}>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <div
                          style={editBtn}
                          onClick={() => {
                            setForm({
                              bank_name: p.bank_name || "",
                              branch: p.branch || "",
                              project_name: p.project_name || "",
                              assigned_to: p.assigned_to || "",
                            });

                            setEditId(p.id);
                            setShowForm(true);
                          }}
                        >
                          <GrEdit size={20} />
                        </div>

                        {/* <div
                          style={deleteBtn}
                          onClick={() => {
                            setDeleteId(p.id);
                            setShowDelete(true);
                          }}
                        >
                          <RiDeleteBin5Line size={20} />
                        </div> */}

                        {p.assigned_to === null && (
  <div
    style={deleteBtn}
    onClick={() => {
      setDeleteId(p.id);
      setShowDelete(true);
    }}
  >
    <RiDeleteBin5Line size={20} />
  </div>
)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        
        {showForm && (
          <div style={overlay}>
            <div style={modal}>
              <h3>{editId ? "Edit Project" : "Add Project"}</h3>

              <input style={input} placeholder="Bank Name" value={form.bank_name} onChange={(e)=>setForm({...form,bank_name:e.target.value})}/>
              <input style={input} placeholder="Branch" value={form.branch} onChange={(e)=>setForm({...form,branch:e.target.value})}/>
              <input style={input} placeholder="Project Name" value={form.project_name} onChange={(e)=>setForm({...form,project_name:e.target.value})}/>

              <select style={input} value={form.assigned_to} onChange={(e)=>setForm({...form,assigned_to:Number(e.target.value)})}>
                <option value="">Select Site Master</option>
                {siteMasters.map((u)=>(
                  <option key={u.id} value={u.id}>{u.name}</option>
                ))}
              </select>

              <div style={{ display: "flex", gap: "10px" }}>
                <button style={btn} onClick={handleSubmit}>Submit</button>
                <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        {/* DELETE MODAL */}
        {showDelete && (
          <div style={overlay}>
            <div style={modal}>
              <h3>Confirm Delete</h3>
              <p>Are you sure you want to delete this project?</p>

              <div style={{ display: "flex", gap: "10px" }}>
                <button style={btn} onClick={confirmDelete}>
                  Yes Delete
                </button>

                <button
                  style={cancelBtn}
                  onClick={() => {
                    setShowDelete(false);
                    setDeleteId(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Manageprojects;

const modal = {
  background: "#fff",
  padding: "25px",
  borderRadius: "12px",
  width: "90%",
  maxWidth: "420px",
};

const input = {
  width: "100%",
  padding: "12px",
  marginBottom: "12px",
  border: "1px solid #ccc",
  borderRadius: "6px",
};

const btn = {
  background: "#D4C2BB",
  color: "#7D4B3C",
  padding: "10px 16px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const cancelBtn = {
  background: "#ddd",
  padding: "10px 16px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const editBtn = {
  padding: "6px",
  borderRadius: "6px",
  background: "#eef2ff",
  cursor: "pointer",
};

const deleteBtn = {
  padding: "6px",
  borderRadius: "6px",
  background: "#ffecec",
  cursor: "pointer",
  color: "#dc3545",
};

const container = {
  background: "#fff",
  borderRadius: "10px",
  padding: "15px",
};

const topBar = {
  display: "flex",
  flexWrap: "wrap",        
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
  marginBottom: "15px",
};

// const searchInput = {
//   padding: "8px 12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
// };

const searchInput = {
  padding: "8px 12px",
  borderRadius: "6px",
  border: "1px solid #ddd",
  flex: "1",
  minWidth: "180px",
};


const addBtn = {
  background: "#D4C2BB",
  color: "#7D4B3C",
  border: "none",
  padding: "8px 15px",
  borderRadius: "6px",
  cursor: "pointer",
};

const tableWrapper = {
  width: "100%",
  overflowX: "auto",
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
};

const th = {
  padding: "12px",
  textAlign: "left",
};

const td = {
  padding: "10px",
};

// const avatar = {
//   width: "32px",
//   height: "32px",
//   borderRadius: "50%",
//   background: "#D4C2BB",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };
const avatar = {
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  background: "#D4C2BB",
  color: "#7D4B3C",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
};

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};